export default {
    setLoading(state, loading)
    {
        state.loading = loading;
    },
    setInvoices(state, {invoices})
    {
        state.invoices = invoices.data;
        state.total = invoices.total;
    }
}
